import React, { useEffect } from "react";
import { useState } from "react";
import "./NewSchedule.css";

import axios from "axios";
import swal from "sweetalert";
import { Table } from "react-bootstrap";

const NewSchedule = ({ schedule, selectedSchedule }) => {
  const [inputFieldList, setInputFieldList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorHandle, setErrorHandle] = useState('');
  useEffect(() => {
    setInputFieldList(selectedSchedule);
    if (selectedSchedule.lenght < 1) {
      setInputFieldList([
        ...selectedSchedule,
        { event_type: "", from: "", to: "", date: schedule.format() },
      ]);
    }
  }, [selectedSchedule]);

  const handleChangeInput = (index, event) => {
    const values = [...inputFieldList];
    values[index][event.target.name] = event.target.value;
    setInputFieldList(values);
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/add_schedule`, inputFieldList).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
        } else if (res.data.status === 422) {
          // swal("Error", res.data.message, "error");
          setErrorHandle(res.data.message);
        } else {
          setInputFieldList({
            ...inputFieldList,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  const handleAddClick = (index) => {
    setInputFieldList([
      ...inputFieldList,
      { event_type: "", from: "", to: "", date: schedule.format() },
    ]);
  };

  const handleRemoveClick = (index) => {
    const fieldList = [...inputFieldList];
    fieldList.splice(index, 1);
    setInputFieldList(fieldList);
  };

  return (
    <>
      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2 border-0">
          <div className="container-lg">
            <div className="row justify-content-center">
              <form
                className="clo-sm-12 col-md-12 col-lg-9 card bg-dark p-3 "
                onSubmit={handleSubmit}
              >
                <div className="d-flex justify-content-between">
                  <div className="div">
                    <h4 className="m-0 card-text lead text-warning">
                      Create Schedule
                    </h4>
                    <small className="text-light">
                      {schedule.day} {schedule.month.name} {schedule.year}
                    </small>
                  </div>
                  <div className="div">
                    <button
                      onClick={() => handleAddClick()}
                      type="button"
                      className="btn btnUpdate fw-bold  " 
                    >
                      <i className="fas fa-plus"></i> &nbsp;New Schedule
                    </button>
                  </div>
                </div>
                <div className="under-line my-1"></div>

                <div className=" mt-2 ">
                  <div style={{ overflowX: "auto" }}>
                    <Table className="table w-100">
                      <thead className="bg-warning">
                        <tr>
                          <th>Event Type</th>
                          <th>Time Start</th>
                          <th>Time End</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {inputFieldList.map((inputField, i) => {
                        return (
                          <tbody className="border-0 ">
                            <tr>
                              <td>
                                <select
                                  className="form-control new-sch "
                                  name="event_type"
                                  onChange={(event) =>
                                    handleChangeInput(i, event)
                                  }
                                  value={inputField.event_type}
                                >
                                  <option value="">Select One</option>
                                  <option value="livechat">Live Chat</option>
                                  <option value="learning">
                                    Learning Session
                                  </option>
                                  <option value="meetup">Meetup Event</option>
                                  <option value="qna">QnA Session</option>
                                </select>
                                {
                                  inputField.event_type ? ' ' : <small className="text-danger">{errorHandle}</small>
                                }
                              </td>
                              <td>
                                <input
                                  className=" form-control new-sch"
                                  type="time"
                                  name="from"
                                  onChange={(event) =>
                                    handleChangeInput(i, event)
                                  }
                                  value={inputField.from}
                                />
                                {
                                  inputField.from ? ' ' : <small className="text-danger">{errorHandle}</small>
                                }
                              </td>

                              <td>
                                {" "}
                                <input
                                  className=" form-control new-sch"
                                  type="time"
                                  name="to"
                                  onChange={(event) =>
                                    handleChangeInput(i, event)
                                  }
                                  value={inputField.to}
                                />
                                {
                                  inputField.to ? ' ' : <small className="text-danger">{errorHandle}</small>
                                }
                              </td>
                              <td>
                                <button className="btn btn-danger mx-1">
                                  <i
                                    className="fas fa-trash-alt text-light"
                                    onClick={() => handleRemoveClick(i)}
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </Table>
                    {loading ? (
                      <button className="btn btn-success fw-bold mx-2">
                        <i className="fas fa-spinner fa-pulse"></i>{" "}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="btn btnCreateS fw-bold mx-2 px-3"
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewSchedule;
